module.exports = ".trip-period-price-item {\n  display: block;\n  position: relative;\n  padding: 1em;\n  border-bottom: solid #E4E9ED 1px;\n}\n\n.delete-trip-button {\n  position: absolute;\n  top: 1em;\n  right: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/subscriptionplans/subscriptionplans-form/subscriptionplans-form.component.css
// module id = ./src/app/subscriptionplans/subscriptionplans-form/subscriptionplans-form.component.css
// module chunks = main